import { Grid, styled } from "~/common/mui";
import { CORNER_MEDIUM } from "~/common/components/icon/Corners";

export const SearchFiltersContainer = styled(Grid)({
  position: "sticky",
  top: "0px",
  height: "calc(100dvh)",
  overflowY: "auto",
  borderRadius: CORNER_MEDIUM,
  paddingTop: 0,
});
